import { UserPermission } from "../auth/access";
import { User } from "../model/user";
import { api } from "./api";

export const getPermissionUsers = async (accessToken: string, permission: UserPermission): Promise<User[]> => {
    const response = await api.get(`/permissions/${permission.toString()}/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data as User[];
}

export const getUserPermissions = async (accessToken: string, userId: string): Promise<UserPermission[]> => {
    const response = await api.get<string[]>(`/users/${userId}/permissions`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    let list: UserPermission[] = []

    for (let permission of response.data ){
        let casted = <UserPermission>permission
        list.push(casted)
    }

    return list;
};

export const grantUserPermission = async (accessToken: string, userId: string, permission: UserPermission): Promise<boolean> => {
    const response = await api.post(`/users/${userId}/permissions/${permission.toString()}`, {
        // empty body
    }, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};

export const removeUserPermission = async (accessToken: string, userId: string, permission: UserPermission): Promise<boolean> => {
    const response = await api.delete(`/users/${userId}/permissions/${permission.toString()}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.status === 200;
};
